module.exports = __webpack_public_path__ + "img/friend-space_zh.629a78b8.png";